<template>
  <div class="component-leadlovers">
    <h5 class="text-semibold mb-5">LeadLovers</h5>
    <snow-data-table-header
      class="mb-6"
      @add="modal = true"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-4 d-flex flex-column align-items-center gap-4">
            <h2 class="text-semibold">Ainda não há nada aqui</h2>
            <img src="@/assets/images/no-content.svg" />
            <h3>Talvez você precise</h3>
            <snow-button
              text="Integrar sua conta"
              icon="ph ph-plus"
              @click="modal = true"
            />
            <h5 class="text-dark-40">
              Integre sua conta de e-mail marketing para garantir um perfeito
              fluxo de disparos para seus clientes
            </h5>
          </div>
        </div>
      </div>
      <div v-else>
        <!-- Desktop area -->
        <snow-data-table :data="integrationList" :columns="columns" />
      </div>
      <div class="d-flex justify-content-end">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
    <lead-lovers-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
      @loading="loading = true"
    />
  </div>
</template>
<script>
import LeadLoversModal from "@/components/tools/modals/LeadLovers.vue";
import { mapState } from "vuex";
export default {
  components: {
    LeadLoversModal
  },
  data() {
    return {
      loading: false,
      integrationToEdit: null,
      page: 1,
      integration: "leadlovers",
      modal: false,
      search: ""
    };
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  computed: {
    ...mapState("integration", ["integrationList", "pagination", "typeEvents"]),
    eventsOptions() {
      let options = [...this.typeEvents];
      options.unshift({ id: "", name: "Todos os eventos" });
      return options;
    },
    columns() {
      return [
        {
          name: "Descrição",
          field: "description"
        },
        {
          name: "Token",
          field: "token"
        },
        {
          name: "Status",
          field: "status",
          transform: v => (v ? "Ativo" : "Inativo"),
          color: v => (v ? "green" : "negative"),
          type: "tag"
        },
        {
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  methods: {
    formatLongText(txt) {
      if (txt) {
        return txt.length > 20 ? `${txt.slice(0, 20)}...` : `${txt}`;
      }
      return "-";
    },
    getActions(item) {
      return [
        {
          label: item.status ? "Desativar" : "Ativar",
          click: this.changeStatus
        },
        {
          label: "Editar",
          class: "",
          click: this.edit
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Deseja mesmo excluir esta integração?",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            secondaryButtonText: "Não, cancelar",
            action: this.submitDelete
          }
        }
      ];
    },
    searching(search) {
      this.search = search;
      this.dispatch();
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", { search: this.search })
        .catch(error => {
          this.$message.error("Não foi possível carregar as integrações");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = item;
      data.status = !item.status;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(error => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    },
    submitDelete(v) {
      this.loading = true;
      this.$store
        .dispatch("integration/deleteIntegration", v.id)
        .then(() => {
          this.dispatch();
          this.$message.success("Integração removida");
        })
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
            this.$message.error("Não foi possível deletar a integração");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    edit(v) {
      this.integrationToEdit = v;
      this.modal = true;
    }
  }
};
</script>
